import api, { clear } from "../api";

export const CREATE_USER_SUCCESS ='CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE ='CREATE_USER_FAILURE';
export const LOGIN_USER_SUCCESS ='LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE ='LOGIN_USER_FAILURE';
export const RECOVERY_USER_SUCCESS ='RECOVERY_USER_SUCCESS';
export const RECOVERY_USER_FAILURE ='RECOVERY_USER_FAILURE';
export const RESET_STORE = 'RESET_STORE';
export const CHANGE_PASSWORD_SUCCESS ='CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD__FAILURE ='CHANGE_PASSWORD__FAILURE';

export var countValidations=0;
export var countSignatures=0;

//Actions
export const createUserSuccess=(value)=>{
    return {
        type: CREATE_USER_SUCCESS,
        payload: value
    }
}

export const createUserFailure=(value)=>{
    return {
        type: CREATE_USER_FAILURE,
        payload: value
    }
}

export const recoveryUserSuccess=(value)=>{
    return {
        type: RECOVERY_USER_SUCCESS,
        payload: value
    }
}

export const recoveryUserFailure=(value)=>{
    return {
        type: RECOVERY_USER_FAILURE,
        payload: value
    }
}

export const loginUserSuccess=(value)=>{
    return {
        type: LOGIN_USER_SUCCESS,
        payload: value
    }
}

export const loginUserFailure=(value)=>{
    return {
        type: LOGIN_USER_FAILURE,
        payload: value
    }
}

// to reset the state of redux store
export const resetStore = () => {
    return {
      type: RESET_STORE
    }
 }

export const changePasswordSuccess=(value)=>{
    return {
        type: CHANGE_PASSWORD_SUCCESS,
        payload: value
    }
}

export const changePasswordFailure=(value)=>{
    return {
        type: CHANGE_PASSWORD__FAILURE,
        payload: value
    }
}

export const createUser=(user, callBack)=>{
    document.body.className='loading';
    return (dispach)=>{
        api.post("/login/create",user)
        .then(response=>{
            //console.log(response.data);
            dispach(createUserSuccess(response.data));
            if (callBack!==undefined){
                callBack(response.data,null);
            }
            document.body.className='';
        }).catch(error=>{
            //console.log(error);
            dispach(createUserFailure(error));
            if (callBack!==undefined){
                callBack(null,error);
            }
            document.body.className='';
        });
    }
}

export const loginUser=(row,callBack)=>{
    document.body.className='loading';
    return (dispach)=>{
        clear();
        api.post("/Usuarios/Login",row)
        .then(response=>{
            //console.log(response.data);
            dispach(loginUserSuccess(response.data));
            sessionStorage.setItem('token', response.data.tocken);
            if (callBack!==undefined){
                callBack(response.data,null);
            }
            document.body.className='';
        }).catch(error=>{
            //console.log(error);
            dispach(loginUserFailure(error));
            if (callBack!==undefined){
                callBack(null,error);
            }
            document.body.className='';
        });
    }
}

export const loginChk=async (row,callBack)=>{
    document.body.className='loading';
    let resp = await api.post("/Usuarios/ChkLogin",row)
    .then(response=>{
        if (callBack!==undefined){
            callBack(response.data,null);
        }
        document.body.className='';
        return response.data
    }).catch(error=>{
        if (callBack!==undefined){
            callBack(null,error);
        }
        document.body.className='';
    });
    return resp;
}

export const recoveryUser=(userName, email, callBack)=>{
    document.body.className='loading';
    return (dispach)=>{
        api.post("/login/recovery",{User:userName,Email:email})
        .then(response=>{
            //console.log(response.data);
            dispach(recoveryUserSuccess(response.data));
            if (callBack!==undefined){
                callBack(response.data,null);
            }
            document.body.className='';
        }).catch(error=>{
            //console.log(error);
            dispach(recoveryUserFailure(error));
            if (callBack!==undefined){
                callBack(null,error);
            }
            document.body.className='';
        });
    }
}

export const changePassword=(userName, password, nPassword, callBack)=>{
    document.body.className='loading';
    return (dispach)=>{
        api.post("/login/cpassword",{User:userName,Password:password, NewPassword: nPassword})
        .then(response=>{
            //console.log(response.data);
            dispach(changePasswordSuccess(response.data));
            if (callBack!==undefined){
                callBack(response.data,null);
            }
            document.body.className='';
        }).catch(error=>{
            //console.log(error);
            dispach(changePasswordFailure(error));
            if (callBack!==undefined){
                callBack(null,error);
            }
            document.body.className='';
        });
    }
}


export const ActivateUser=(key,callBack)=>{
    document.body.className='loading';
    return (dispach)=>{
        api.post("/Usuarios/Activate", null, { params: {
            key
          }})
        .then(response=>{
            if (callBack!==undefined){
                callBack(response.data,null);
            }
            document.body.className='';
        }).catch(error=>{
            //console.log(error);
            if (callBack!==undefined){
                callBack(null,error);
            }
            document.body.className='';
        });
    }
}

export default createUser;